import { useCallback, useMemo } from 'react';
import {
  ArtifactCodeV3,
  ArtifactMarkdownV3,
  isArtifactCode,
  isArtifactMarkdown,
} from 'src/types';
import { useClearEditorText } from './useClearEditorText';
import { useClearCodeEditor } from './useClearCodeEditor';
import { useInsertTextToEditor } from './useInsertTextToEditor';
import { useInsertCodeToEditor } from './useInsertCodeToEditor';
import { useCodeEditorActions } from './useCodeEditorActions';

export const useEditorControl = () => {
  const { clearEditorText } = useClearEditorText();
  const { clearCodeEditorContent } = useClearCodeEditor();
  const { setCodeEditorData } = useCodeEditorActions();
  const { insertCodeToEditor } = useInsertCodeToEditor();
  const { insertTextToEditor } = useInsertTextToEditor();

  const onInsertArtifactToEditor = useCallback(
    (artifact?: ArtifactMarkdownV3 | ArtifactCodeV3) => {
      if (isArtifactMarkdown(artifact)) {
        clearEditorText();
        insertTextToEditor({ markdown: artifact.fullMarkdown });
        return;
      }

      if (isArtifactCode(artifact)) {
        const { code, language } = artifact;
        clearCodeEditorContent();
        insertCodeToEditor({ codeContent: code });
        setCodeEditorData({ content: code, language });
        return;
      }
    },
    [
      clearCodeEditorContent,
      clearEditorText,
      insertCodeToEditor,
      insertTextToEditor,
      setCodeEditorData,
    ],
  );

  return useMemo(
    () => ({
      onInsertArtifactToEditor,
    }),
    [onInsertArtifactToEditor],
  );
};
